
/**
 * Constants for take action Ids.
 */
export const __NOTIFY_REQUEST_DOCS_ID__ = 1;
export const __REQUEST_ADDITIONAL_INFO_ID__ = 2;
export const __RESPOND_TO_ISSUER_ID__ = 3;
export const __UNABLE_TO_DEFEND_PURSUE_ID__ = 4;
export const __WRITEOFF_GOODWILL_ID__ = 6;
export const __ISSUER_IMAGE_DATA__ = 'issuerImageData';
export const __MERCHANT_IMAGE_DATA__ = 'merchantImageData';
export const __CLOSE_CASE_ID__ = 7;
export const __ADD_CASE_NOTES_ID__ = 8;
export const __PEND_CASE_ID__ = 10;
export const __UNPEND_CASE_ID__ = 11;
export const __TRANSFER_CASE_ID__ = 12;
export const __UNABLETO_FULFILL_ID__ = 13;
export const __RESPOND_TO_CARD_BRAND_ID__ = 14;
export const __PURSUE_CASE_FILLING_ID__ = 16;
export const __MANUALLY_PROCESSED_ID__ = 17;
export const __REQUEST_ISSUER_DOCUMENT_ID__ = 18;

/**
 * Constants for Id of Component rendered
 */
//  RESPOND TO ISSUER ID component Ids
export const __RESPOND_TO_ISSUER_ADJST_FINANCIAL_ID__ = 1;
export const __RESPOND_TO_ISSUER_QUESTIONNAIRE_ID__ = 2;
export const __RESPOND_TO_ISSUER_MERCH_MSG_ID__ = 4;
export const __RESPOND_TO_ISSUER_REVIEW_ID__ = 6;
export const __RESPOND_TO_ISSUER_ISSUER_DOCS_ID__ = 3;// unable to defend attach array id (optional)
export const __RESPOND_TO_ISSUER_MERCH_DOCS_ID__ = 5;// unable to defend attach array id (optional)

// UNABLE TO DEFEND OR PURSUE component Ids
export const __UNABLE_TO_DEFEND_PURSUE_MERCH_MSG_ID__ = 12;
export const __UNABLE_TO_DEFEND_PURSUE_REVIEW_ID__ = 13;
export const __UNABLE_TO_DEFEND_PURSUE_ACCEPT_LIABILITY_ID__ = 14;// unable to defend attach array id (optional)
export const __UNABLE_TO_DEFEND_PURSUE_MERCH_DOCS_ID__ = 15;// unable to defend attach array id (optional)
export const __UNABLE_TO_DEFEND_PURSUE_ADJST_FINANCIAL_ID__ = 16;// unable to defend attach array id (optional)

// Request Additional info component ids

export const __REQUEST_ADDITIONAL_INFO_MERCH_MSG_ID__ = 17;
export const __REQUEST_ADDITIONAL_INFO_REVIEW_ID__ = 18;
export const __REQUEST_ADDITIONAL_INFO_MERCH_DOCS_ID__ = 19; // additional attach array id (optional)

// Write off or Good Will component ids

export const __WRITEOFF_GOODWILL_ADJST_FINANCIAL_ID__ = 20;
export const __WRITEOFF_GOODWILL_WRITE_OFF_REASON_ID__ = 21;
export const __WRITEOFF_GOODWILL_MERCH_MSG_ID__ = 22;
export const __WRITEOFF_GOODWILL__REVIEW_ID__ = 23;
export const __WRITEOFF_GOODWILL_ACCEPT_LIABILITY_ID__ = 24;// unable to defend attach array id (optional)
export const __WRITEOFF_GOODWILL_MERCH_DOCS_ID__ = 25;// unable to defend attach array id (optional)


// Notify and request document component ids
export const __NOTIFY_AND_REQUEST_MERCH_MSG_ID__ = 34;
export const __NOTIFY_AND_REQUEST_REVIEW__ID__ = 35;
export const __NOTIFY_AND_REQUEST_MERCH_DOCS_ID__ = 36;// Notify and request attach array id (optional)
export const __NOTIFY_AND_REQUEST_ADJST_FINANCIAL_ID__ = 37;// Notify and request attach array id (optional)

//Close case page ids
export const __CLOSE_CASE_MERCH_MSG_ID = 28;
//Transfer case component Ids
export const __TRANSFER_CASE_TRANSFERTO_ID__ = 38;

//Unable to fullfill constants
export const __UNABLETO_FULFILL_MERCH_MSG_ID__ = 39;
export const __UNABLETO_FULFILL_ACCEPT_LIABILITY_ID__ = 40;
export const __UNABLETO_FULFILL_MERCH_DOCS_ID__ = 41;
export const __UNABLETO_FULFILL_REVIEW__ID__ = 42;

//Request Issuer Document
export const __REQUEST_ISSUER_DOCUMENT__ = 46;

// Upload douments
export const __UPLOAD_DOCUMENT__ = 101;
//Create Document
export const __CREATE_DOCUMENT_ID__ = 102;

// Submit action constants for writeOff/unableToDefend/respondToIssuer
export const __ACCEPT_LIABILITY_KEY__ = 'liabilityInfo';
export const __WRITE_OFF_REASON_KEY__ = 'writeOffReason';
export const __FINANCIAL_ADJUSTMENT_KEY__ = 'financialAdjustment';
export const __MERCHANT_MESSAGE_KEY__ = 'merchantMessage';
export const __MERCHANT_ADVICE_KEY__ = 'merchantAdvice';
export const __REPRESENTMENT_QUESTION_KEY__ = 'representmentQuestion';
export const __CLOSE_CASE_KEY__ = 'closeCaseReason';
export const __REVIEW_ACTION_KEY__ = 'reviewComment';
// attach type constants
export const __ADJUST_FINANCIAL__ = 'adjustFinancial';
export const __ISSUER_DOCS__ = 'issuer';
export const __MERCHANT_DOCS__ = 'merchant';
export const _CLOSE_ACTION_DOCS = 'all';

//Take action title constants
export const __NOTIFY_REQ_DOCS_TITLE__ = "Notify & Request Docs";
export const __WRITE_OFF_GOODWILL_TITLE__ = 'Write off or Goodwill';
export const __REQUEST_ADDON_INFO_TITLE__ = 'Request Additional Info';
export const __RESPOND_TO_ISSUER_TITLE__ = 'Respond to Issuer';
export const __UNABLE_TO_DEFEND_TITLE__ = 'Unable to Defend/Pursue';
export const __CLOSE_CASE_TITLE__ = 'Close Case';
export const __UNPEND_CASE_TITLE__ = 'Unpend Case';
export const __PEND_CASE_TITLE__ = 'Pend Case';
export const __TRANSFER_CASE_TITLE__ = 'Transfer Case';
export const __ADD_NOTES_TITLE__ = 'Add Case Notes';
export const __PURSUE_CASE_TITLE__ = 'Pursue Case Filing';
export const __UPLOAD_DOC_TITLE__ = 'Upload Document';
export const __CREATE_DOC_TITLE__ = 'Create Document';
export const __UNABLE_TO_FULFIL_TITLE__ = 'Unable to Fulfill';
export const __RESPOND_TO_CARD_BRAND_ID_TITLE__ = 'Respond to Card Brand';
export const __MANUALLY_PROCESSED_ID_TITLE__ = 'Manually Processed';
export const __REQUEST_ISSUER_DOC_TITLE__ = 'Request Issuer Docs';


export const PRE_POPULATED_FIELD_MAP = {
    1120: 'issuerAdjustmentAmount',
    1320: 'merchantAdjustmentAmount',
};
export const languageMapper = [
    {
        languageIndCode: 'EN',
        languageText: 'English',
    },
    {
        languageIndCode: 'FRN',
        languageText: 'French',
    },
    {
        languageIndCode: 'FR',
        languageText: 'French',
    },
    {
        languageIndCode: 'CH',
        languageText: 'Chinese',
    },
    {
        languageIndCode: 'CHN',
        languageText: 'Chinese',
    },
    {
        languageIndCode: 'ES',
        languageText: 'Spanish',
    }
];
export const MERCHANT_GL = '1320: Merchant GL';
export const __ON_KEY_DOWN__ = 'keydown';
export const __ON_KEY_PRESS__ = 'keypress';
export const __UNDER_SCORE__ = "_";
export const __EMPTY_STRING__ = "";
export const __VISA_BRAND_CODE__ = 'VI';
export const __DISCOVER_BRAND_NAME__ = 'Discover';
export const __VISA_BRAND_NAME__ = 'VISA';
export const __PUSH__ = 'push';
export const __POP__ = 'pop';
export const __MASTERCARD_BRAND_CODE__ = 'MC';
export const __MASTERCARD_BRAND_NAME__ = 'MasterCard';
export const __AMEX_BRAND_CODE__ = 'AX';
export const __AMEX_BRAND_NAME__ = 'Amex';
export const PIN_DEBIT_ACQUIRERS_LIST = ['GPNPD','HPYPD'];

